export function sameAs(a, b) {
    return a === b;
}
